export default __webpack_public_path__ + "static/media/sell.88525236.svg";